export default __webpack_public_path__ + "static/assets/e0bd6ae54e1f14d712bb2bb5a01ce267.png";